/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  ContainerOutlined,
  CopyOutlined,
  EditOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  Loading3QuartersOutlined,
  MoreOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Progress, Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import pluralize from 'pluralize';
import styles from 'styles/components/cycleCard.module.scss';
import { MODULES_ITEMS } from 'utils/constants';
import { getTagFromStatus } from 'utils/utils';

const CycleCard = ({
  cycle,
  onRename,
  onArchive,
  onDuplicate,
  duplicateLoading,
}) => {
  const daysTotal = dayjs(cycle.deadline).diff(dayjs(cycle.startedAt), 'day');
  const daysPassed = dayjs().diff(dayjs(cycle.startedAt), 'day');

  const items = [
    {
      label: (
        <a
          onClick={cycle?.isArchived ? undefined : onRename}
          disabled={cycle?.isArchived}
        >
          <EditOutlined />
          &nbsp;Rename cycle
        </a>
      ),
      key: 'rename',
    },
    {
      label: (
        <a onClick={onDuplicate}>
          {duplicateLoading ? <Loading3QuartersOutlined /> : <CopyOutlined />}
          &nbsp;Duplicate cycle
        </a>
      ),
      key: 'duplicate',
    },
    {
      label: (
        <a onClick={onArchive}>
          <ContainerOutlined />
          &nbsp;
          {cycle.isArchived ? 'Unarchive cycle' : 'Archive cycle'}
        </a>
      ),
      key: 'archive',
    },
  ];

  const isLive = cycle?.status === 'LIVE' && dayjs(cycle.deadline) > dayjs();

  return (
    <div
      className={`${styles.cycle} ${(isLive && !cycle.isArchived) ? styles.cycleCardLive : ''}`}
      key={cycle._id}
    >
      {isLive && !cycle.isArchived && cycle.stats.reviewsCount !== cycle.stats.reviewsTotal && (
        <div className={styles.cycleCardLivePulse}></div>
      )}
      <div className={styles.cycleInner}>
        <div className={styles.cycleDetails}>
          <div className={styles.cycleName}>
            <a href={`/#/cycles/${cycle._id}`} className={styles.cycleLink}>
              <h2>{cycle.name}</h2>
            </a>
          </div>
          <div className={styles.cycleDescription}>
            {cycle.modules.map((module, i) => (
              <div key={`${module.type}-${i}`}>
                <FileTextOutlined />
                &nbsp;{MODULES_ITEMS[module.type].labelShort}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.cycleRightWrapper}>
          <div className={styles.cycleRight}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {cycle.isArchived && <Tag color="grey">Archived</Tag>}
              {getTagFromStatus(cycle)}
            </div>
            {isLive && !cycle.isArchived && (
              <Tooltip
                title={
                  <div>
                    Deadline on{' '}
                    {dayjs(cycle.deadline).format('Do MMM YYYY HH:mm')}
                  </div>
                }
              >
                <div className={styles.cycleDeadline}>
                  {`${dayjs(cycle.deadline).diff(
                    dayjs(),
                    'days'
                  )} ${pluralize('day', dayjs(cycle.deadline).diff(dayjs(), 'day'))} remaining`}
                  &nbsp;
                  <InfoCircleOutlined />
                </div>
              </Tooltip>
            )}
            {(cycle?.status === 'DRAFT' ||
              (cycle?.status === 'LIVE' &&
                dayjs(cycle.deadline) < dayjs())) && (
                <div className={styles.cycleParticipants}>
                  <UserOutlined />
                  &nbsp;
                  {cycle?.stats.usersTotal} participants
                </div>
              )}
          </div>
          <div className={styles.cycleActions}>
            <Dropdown menu={{ items }} trigger={['click']}>
              <Button ghost type="secondary">
                <MoreOutlined className={styles.cycleModuleActionMore} />
              </Button>
            </Dropdown>
          </div>
        </div>
      </div>
      {isLive && !cycle.isArchived && (
        <div className={styles.cycleStats}>
          <div className={styles.cycleStatsItem}>
            <div className={styles.cycleStatsItemInner}>
              <div className={styles.cycleStatsItemValue}>
                {`${cycle.stats.reviewsCount} / ${cycle.stats.reviewsTotal}`}
              </div>

              <div className={styles.cycleStatsItemLabel}>
                Reviews collected
              </div>
            </div>
            <div>
              <Progress
                percent={(
                  (cycle.stats.reviewsCount / cycle.stats.reviewsTotal) *
                  100
                ).toFixed(0)}
                size="small"
                status={
                  cycle.stats.reviewsCount < cycle.stats.reviewsTotal
                    ? 'active'
                    : ''
                }
              />
            </div>
          </div>
          <div className={styles.cycleStatsItem}>
            <div className={styles.cycleStatsItemInner}>
              <div className={styles.cycleStatsItemValue}>
                {`${cycle.stats.usersCount} / ${cycle.stats.usersTotal}`}
              </div>
              <div className={styles.cycleStatsItemLabel}>
                Employee reviewed
              </div>
            </div>
            <div>
              <Progress
                percent={(
                  (cycle.stats.usersCount / cycle.stats.usersTotal) *
                  100
                ).toFixed(0)}
                size="small"
                status={
                  cycle.stats.usersCount < cycle.stats.usersTotal
                    ? 'active'
                    : ''
                }
              />
            </div>
          </div>
          <div className={styles.cycleStatsItem}>
            <div className={styles.cycleStatsItemInner}>
              <div className={styles.cycleStatsItemValue}>
                {`${daysPassed} / ${daysTotal}`}
              </div>
              <div className={styles.cycleStatsItemLabel}>Days Passed</div>
            </div>
            <div>
              <Progress
                percent={((daysPassed / daysTotal) * 100).toFixed(0)}
                size="small"
                status={daysPassed < daysTotal ? 'active' : ''}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CycleCard;
